export default __webpack_public_path__ + "static/r-pitch-4-13176bd5d674b1b0146e5499f043f34e.jpg";